import { render } from "./ExpandCollapseTransition.vue?vue&type=template&id=5735c4af&ts=true"
import script from "./ExpandCollapseTransition.vue?vue&type=script&lang=ts"
export * from "./ExpandCollapseTransition.vue?vue&type=script&lang=ts"

import "./ExpandCollapseTransition.vue?vue&type=style&index=0&id=5735c4af&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__